module.exports = __webpack_public_path__ + "img/fb@3x.defc7e1f.png";